import { useClient } from "@adamlip/okeoke.client";
import { AppParamsContext } from "contexts/AppParamsContext";
import { useEffect, useRef, useContext } from "react";
import { Link, scrollSpy } from "react-scroll";

export default function CategoryBox({
  categories,
  categoryUUID,
  selectedCategory,
  setSelectedCategory,
  scrollToElement,
  addRefToArray,
}) {
  const { getName } = useClient();
  const { appParams } = useContext(AppParamsContext);
  const ref = useRef(null);
  const ref2 = useRef(null);

  useEffect(() => {
    if (ref.current != null && typeof addRefToArray === "function")
      addRefToArray(ref);

    scrollSpy.update();
    // eslint-disable-next-line
  }, []);

  const handleClickOnCategory = (uuid) => {
    if (typeof setSelectedCategory === "function") setSelectedCategory(uuid);
  };

  const handleSetActive = (to) => {
    if (typeof scrollToElement === "function") scrollToElement(to);
  };

  return (
    <div
      className={`orderItemCategory-item ${
        categoryUUID === selectedCategory ? "active" : ""
      }`}
      id={`categList_${categoryUUID}`}
      ref={ref}
    >
      <Link
        activeClass="active"
        to={`orderItemList-byCategory_${categoryUUID}`}
        containerId="orderItemList-byCategory"
        onClick={() => handleClickOnCategory(categoryUUID)}
        smooth={true}
        duration={500}
        spy={true}
        onSetActive={handleSetActive}
      >
        <div ref={ref2} style={{ width: "100%", height: "100%" }}>
          {/* <OEAsset
          uuid={categories[categoryUUID]?.attributes.appImage}
          addClass={"orderItemCategory-img"}
          size="l"
        /> */}
          <div
            className={`orderItemCategory-name ${
              appParams?.styles?.fonts?.capitalize
                ? "font-extrabold uppercase"
                : ""
            }`}
          >
            {getName(categories?.[categoryUUID]?.name)}
          </div>
        </div>
      </Link>
    </div>
  );
}
